/**
 * Constant
 */
export const DI_API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT;
export const DI_FETCH_ON_FOCUS = import.meta.env.VITE_FETCH_ON_FOCUS;
export const URL_SEARCH_PARAM = 'search';
export const MOBILE_BREAKPOINT_WIDTH = 768;
